module.exports = __webpack_public_path__ + "img/BP.d48cad34.png";